// src/component/ViewDocsModal.jsx
import React from "react";

export default function ViewDocsModal({ vehicle, onClose }) {
  if (!vehicle) return null;

  const apiUrl = process.env.REACT_APP_URL;
  const fileBaseUrl = apiUrl + "/uploads/";
  console.log('test')
  const docs = [
    { label: "Tax", url: vehicle.taxFileName ? fileBaseUrl + vehicle.taxFileName : null },
    { label: "Fitness", url: vehicle.fitnessFileName ? fileBaseUrl + vehicle.fitnessFileName : null },
    { label: "Insurance", url: vehicle.insuranceFileName ? fileBaseUrl + vehicle.insuranceFileName : null },
    { label: "Pollution", url: vehicle.pollutionFileName ? fileBaseUrl + vehicle.pollutionFileName : null },
    { label: "Permit", url: vehicle.permitFileName ? fileBaseUrl + vehicle.permitFileName : null },
  ];
  console.log(docs);

  return (
    <>
      <div className="modal show fade d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Documents - {vehicle.number}</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>

            <div className="modal-body">
              <ul className="list-group">
                {docs.map(
                  (doc, i) =>
                    doc.url && (
                      <li
                        key={i}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        {doc.label}
                        <a
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                          className="btn btn-sm btn-success"
                        >
                          Download
                        </a>
                      </li>
                    )
                )}
              </ul>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}
